export enum ErrorTooltipType {
  OVERVALUED = 1,
  UNDERVALUED = 2,
}
